import { TFunction } from "i18next";
import { DeviceWithVehicleInfo } from "@/models/DeviceWithVehicleInfo";

/** One line of the vehicle's identification: what it is called, and what it says. */
export interface VehicleField {
  label: string;
  value: string;
}

/**
 * What identifies the vehicle a checklist belongs to.
 *
 * Shared by the panel above the checklist and by the exported sheet, so the two cannot come to
 * disagree about which fields identify a vehicle — a difference nobody would notice until an
 * archived sheet turned out to be missing the one field someone needed.
 *
 * @param device - The selected vehicle.
 * @param t - Translator.
 * @param notFound - What to show for a field the database does not carry.
 */
export function vehicleIdentification(
  device: DeviceWithVehicleInfo | null | undefined,
  t: TFunction,
  notFound: string,
): VehicleField[] {
  const field = (value: string | undefined) => value?.trim() || notFound;

  return [
    { label: t("liveData.checklist.assetName", "Asset name"), value: field(device?.name) },
    { label: t("vin", "VIN"), value: field(device?.vehicleIdentificationNumber) },
    {
      label: t("liveData.checklist.telematicsSerialNumber", "Telematics serial number"),
      value: field(device?.serialNumber),
    },
    {
      label: t("liveData.checklist.licensePlate", "License plate"),
      value: field(device?.licensePlate),
    },
  ];
}
